import { BaseVue, Component, State, Mutation } from '@newview/base-web';
import { Tool } from "./schema/UISchema";
@Component({ components: {} })
export default class ToolsPanel extends BaseVue {

    //#region 变量区

    topTools: Tool[] = [];

    bottomTools: Tool[] = [];

    //#endregion 

    //#region 事件区

    mounted() { }

    //#endregion 

    //#region 

    setTools(topTools: Tool[] = [], bottomTools: Tool[] = []) {
        this.topTools = topTools;
        this.bottomTools = bottomTools;
    }

    doItemClick(tool: Tool, isTool: boolean = true) {
        if (isTool) { this.setToolStatus(tool); } // 设置激活状态
        if (tool.onclick) { tool.onclick(tool); }
    }

    /**
     * 设置状态
     * @param tool 
     * @returns 
     */
    setToolStatus(tool: Tool) {
        if (this.isNull(tool.groupName)) {
            return;
        }

        const groupTools = this.topTools.filter(item => item.groupName == tool.groupName);
        const currentActiveTools = groupTools.filter(item => item.isActive == true);

        if (currentActiveTools.length == 0) { // 没有激活的数据
            tool.isActive = true;
            return;
        }

        const currentActiveTool = currentActiveTools[0];

        if (currentActiveTool.name == tool.name && tool.isOpenClose == true) { // 点击的是自己，切配置互斥
            tool.isActive = !tool.isActive;
            return;
        }

        if (currentActiveTool.name != tool.name) { // 上次点击的不是自己
            currentActiveTool.isActive = false;
            tool.isActive = true;
            return;
        }
    }

    /**
     * 获取Icon
     * @param tool 
     * @returns 
     */
    getIconClass(tool: Tool) {
        if (this.isNull(tool.activeIcon)) {
            return tool.icon;
        }

        if (tool.isActive) {
            return tool.activeIcon;
        }

        return tool.icon;
    }

    //#endregion

}